import React, { forwardRef } from "react";
import { Bot, User } from "lucide-react";

const Bubble = ({ sender, text }) => {
  const isUser = sender === "user";

  return (
    <div
      className={["flex", isUser ? "justify-start" : "justify-end"].join(" ")}
    >
      <div
        className={[
          "max-w-[92%] sm:max-w-[75%] rounded-3xl px-4 py-3",
          "ring-1 shadow-sm",
          isUser
            ? "bg-blue-600 text-white ring-blue-600/20"
            : "bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 ring-slate-200 dark:ring-slate-800",
        ].join(" ")}
      >
        <div className="flex items-start gap-2">
          <span className="mt-0.5">
            {isUser ? (
              <User className="w-4 h-4 opacity-90" />
            ) : (
              <Bot className="w-4 h-4 text-blue-600 dark:text-blue-400" />
            )}
          </span>
          <p className="text-sm leading-7 whitespace-pre-wrap break-words">
            {text}
          </p>
        </div>
      </div>
    </div>
  );
};

const ChatArea = forwardRef(({ messages, loading }, ref) => {
  return (
    <section className="flex-1 overflow-y-auto px-3 sm:px-5 py-4" ref={ref}>
      <div className="space-y-3">
        {messages.length === 0 && !loading && (
          <div className="rounded-3xl bg-slate-50 dark:bg-slate-900/40 ring-1 ring-slate-200 dark:ring-slate-800 p-5 text-right">
            <div className="text-sm font-bold text-slate-900 dark:text-slate-100">
              شروع کنید
            </div>
            <div className="mt-1 text-xs text-slate-600 dark:text-slate-300">
              سوال خود را بنویسید و Enter را بزنید.
            </div>
          </div>
        )}

        {messages.map((m, i) => (
          <Bubble key={i} sender={m.sender} text={m.text} />
        ))}

        {loading && (
          <div className="flex justify-end">
            <div className="max-w-[92%] sm:max-w-[75%] rounded-3xl px-4 py-3 bg-white dark:bg-slate-900 ring-1 ring-slate-200 dark:ring-slate-800 shadow-sm">
              <div className="flex items-center gap-2 text-sm text-slate-700 dark:text-slate-200">
                <span className="inline-flex w-2 h-2 rounded-full bg-slate-400 animate-pulse" />
                در حال پاسخ‌گویی…
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
});

export default ChatArea;
